import styled from "styled-components/macro";
import { Logo, SignupButton } from "../features/components/Nav.styles";
import background from '../assets/images/top-movies.webp'

export const JoinPageWrapper = styled.div`
  padding-top: 91px;
  min-height: 100vh;
  width: 100%;
  background-color: black;
  padding-bottom: 240px;
  @media (min-width: 700px) {
    padding-bottom: 400px;
  }
`;
export const JoinHeroImg = styled.div`
  background-repeat: no-repeat;
  background-position: center center;
  background-size: cover;
  border-style: none;
  margin-left: auto;
  margin-right: auto;
  margin-bottom: 0px;
  border-radius: 0px;
  height: clamp(320px, 40vw, 721px);
  position: relative;
  background-image: url(${background});
  padding: clamp(30px, 10vw, 50px);
  text-align: center;
  display: flex;
  justify-content: center;
  flex-direction: column;
  align-items: center;
`;
export const HeroHeader = styled.h1`
  font-weight: 900;
  font-size: clamp(20px, 5vw, 52px);
  color: rgb(255, 255, 255);
  font-style: normal;
  background-color: rgba(0, 0, 0, 0);
  max-width: 900px;
  line-height: 1.2;
  margin-bottom: 0.1em;
`;

export const ProviderSVG = styled.img`
  max-width: 600px;
  align-self: center;
`;
export const HeroExplainer = styled.p`
  font-size: clamp(15px, 3vw, 28px);
  color: rgb(255, 255, 255);
  font-weight: 300;
  font-style: normal;
  max-width: 800px;
`;

export const SignUp = styled(SignupButton)`
  && {
    max-width: 485px;
    height: clamp(44px, 10vw, 88px);
    font-size: clamp(12px, 3vw, 28px);
    line-height: 34px;
    font-weight: 900;
    padding: 20px 40px;
    border-radius: 6px;
  }
`;

export const ContentSection = styled.section`
position: relative;
  display: flex;
  flex-direction: column-reverse;
  align-items: center;
  padding: 20px 20px;
  @media (min-width: 700px) {
    flex-direction: row;
    justify-content: center;
    margin: auto;
    padding: 20px 60px;
    max-width: 900px;
  }
`;
export const SecondarySection = styled.section`
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 20px 20px;
  @media (min-width: 700px) {
    justify-content: center;
    margin: auto;
    padding: 20px 60px;
    max-width: 900px;
  }
`;

export const RefPoint = styled.div`
  padding-top: 90px;    
  margin-top: -90px;      
`

export const SecondaryHeader = styled.h2`
  font-weight: 900;
  font-size: clamp(15px, 5vw, 35px);
  color: rgb(255, 255, 255);
  font-style: normal;
  background-color: rgba(0, 0, 0, 0);
  max-width: 900px;
  line-height: 1.2;
  margin-bottom: 0.3em;
`;
export const HowItWorksExplainer = styled.div`
position: relative;
  width: 100%;
  margin: auto;
  font-size: 12px;
  height: fit-content;
  @media (min-width: 700px) {
    width: 40%;
    margin-right: 10%;
  }
`;

export const HowItWorksText = styled.p`
  font-size: clamp(18px, 2vw, 24px);
  color: rgb(255, 255, 255);
  font-weight: 300;
  font-style: normal;
`

export const HowItWorksImage = styled.img`
  position: absolute;
  max-width: 50%;
  z-index: 1;
  top: -10%;
  @media (min-width: 700px) {
    max-width: 70%;
    right: -10%;
  }
`;

export const HowItWorksMovieImage = styled.img`
  position: absolute;
  max-width: 100%;
  max-height: 220px;
  left:0;
  @media (min-width: 700px) {
    max-height: 100%;
    left: -10%;
  }
`

export const HowItWorksImageWrappers = styled.div`
  display: flex;
  justify-content: flex-end;
  position: relative;
  width:100%;
  height: 100%;;
  min-height: 250px;
  margin-top: 30px;
  @media (min-width: 700px) {
    width: 50%;
    margin-top: 0px;
  }
`



export const RowImage = styled.img`
  width: 100%;
`;
export const RowWrapper = styled.div``;

export const JoinNav = styled.div`
  height: 100px;
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  position: fixed;
  top: 0;
  z-index: 9;
  background-color: black;
  @media (min-width: 900px) {
    height: 91px;
  }
`;


export const JoinNavContent = styled.div`
  max-width: 900px;
  width: 100%;
  display: flex;
  justify-content: space-around;
  align-items: center;
  padding: 0 20px;
  margin-top: 10px;
  @media (min-width: 900px) {
    justify-content: space-evenly;
    margin-top: 0px;
  }
`;
export const JoinNavLink = styled.div`
  color: #999;
  font-weight: 600;
  font-size: clamp(10px, 3vw, 16px);
  &:hover {
    cursor: pointer;
    color: gray;
  }
`;
export const JoinFreeTrialButton = styled(SignupButton)`
  && {
    width: clamp(80px, 15vw, 135px);
    height: clamp(30px, 5vw, 50px);
    font-size: clamp(12px, 2vw, 18px);
    font-weight: 900;
    margin: 0;
    border-radius: 6px;
    /* padding: clamp(12px, 5vw, 20px); */
  }
`;
export const UpperLinkContainer = styled.div`
  display: none;
  @media (min-width: 900px) {
    max-width: 450px;
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: space-around;
  }
`;

export const LinkContainer = styled.div`
  margin-top: 10px;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-around;
  @media (min-width: 900px) {
    display: none;
  }
`;
export const LoginJoinNav = styled.div`
  font-size: clamp(16px, 3vw, 20px);
  color: #999;
  margin-left: 20px;
  font-weight: 900;
  &:hover {
    cursor: pointer;
    color: gray;
  }
  @media (min-width: 900px) {
    margin-left: 30px;
  }
`;

export const ButtonLoginContainer = styled.div`
    display: flex;
    align-items: center;
    justify-content: space-between;
`;

export const JoinLogo = styled(Logo)`
        width: 150px;
        height: unset;
        &:hover{
            cursor: pointer;
        }
`
